import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import { LocaleUtil } from '../utils';
import { V2_PERMISSION_API_KEY_MAP } from '../utils/consts';

/**
 * [Model] PermissionItem
 */
var PermissionItem = /*#__PURE__*/function () {
  function PermissionItem() {
    _classCallCheck(this, PermissionItem);
  }
  return _createClass(PermissionItem, null, [{
    key: "parseV2",
    value:
    /**
     * Parse camel case data from command processor V2 API
     */
    function parseV2(data) {
      var rowData = data || {};
      var permission = new PermissionItem();
      permission.id = rowData[V2_PERMISSION_API_KEY_MAP.id];
      permission.oxygenId = rowData[V2_PERMISSION_API_KEY_MAP.oxygenId];
      permission.accessType = rowData[V2_PERMISSION_API_KEY_MAP.accessType];
      permission.type = rowData[V2_PERMISSION_API_KEY_MAP.type];
      permission.status = rowData[V2_PERMISSION_API_KEY_MAP.status];
      permission.name = rowData.name;
      permission.email = rowData.email;

      //for permissions
      permission.actions = rowData.actions;
      permission.inheritActions = rowData.inheritActions;

      // to support translate group user name
      if (permission.type === 'GROUP' && (permission.name || '').toLowerCase() === 'everyone') {
        permission.name = LocaleUtil.translate('permissions.everyone');
      }
      return permission;
    }

    /**
     * Parse camel case data from command processor v3 API
     */
  }, {
    key: "parseV3",
    value: function parseV3(data) {
      var rowData = data || {};
      var permission = new PermissionItem();
      permission.id = rowData.subjectId;
      permission.oxygenId = rowData.autodeskId;
      permission.type = rowData.subjectType;

      //for permissions
      permission.actions = rowData.actions;

      // to support translate group user name and sheet service will only return one group which is everyone
      if (permission.type === 'GROUP') {
        permission.name = LocaleUtil.translate('permissions.everyone');
      }
      return permission;
    }
  }]);
}();
export { PermissionItem as default };